const radius = {
  none: "unset",
  tagRadius: "6px",
  chipRadius: "6px",
  cardRadius: "8px",
  carouselRadius: "10px",
  half: "50%",
  textInputRadius: "12px",
} as const;

export default radius;
